import { container } from '@k-mille/ui-components'
import Component from './cgv'

const intl = 'cgv'

export default container({
  intl,
})(Component)
